<template>

  <PrevisionaleIncassi />
 
</template>

<script>
import PrevisionaleIncassi from '../components/pratiche/PrevisionaleIncassi.vue'

export default {
  components: {
    PrevisionaleIncassi

  },
  data() {
    return {

    }
  },

  created(){
    
  },

  mounted(){
    this.$eventBus.emit('page-change', {
      target: this,
      currentRoute: this.$router.currentRoute.value
    })
  },

  methods: {
    
  },
}
</script>

